// LICENSE : MIT
"use strict";
const types = require("../data/index.json");
import {parse} from "./ecmascript-version-detector";
module.exports = {
    types,
    parse
};